import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WebButton } from 'elements/button/WebButton';
import { useLinkMapAndGuideToUser } from 'hooks/ownership/useLinkMapAndGuideToUser';
import { SVG_Logo } from 'libs/images/SVG_Logo';
import { EColors, EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { GlobalContext } from 'session/state/context';
import { setLoggedUser } from 'session/state/user/userActions';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    disableLogin?: boolean;
    className?: string;
}

export const MinutePageHeader = (props: Props): JSX.Element => {
    const globalContext = useContext(GlobalContext);
    const user = globalContext.state.loggedUser;
    const navigate = useNavigate();

    function logout() {
        globalContext.dispatch(setLoggedUser(null));
        navigate('/');
    }

    useLinkMapAndGuideToUser();

    return (
        <S_MinutePageHeader className={props.className}>
            <Link to="/admin">
                <S_Logo />
            </Link>
            {!props.disableLogin && globalContext.state.loggedUserChecked && (
                <>
                    {user && (
                        <S_ProfileName>
                            <S_Icon
                                icon={['fas', 'user']}
                                onClick={() => {
                                    navigate('/account');
                                }}
                            />
                            <S_Profile
                                onClick={() => {
                                    navigate('/account');
                                }}
                            >
                                {/* Some old users do not have email */}
                                {(user.email ?? user.userId).split('@')?.[0]}
                            </S_Profile>
                            <S_Out onClick={logout}>({Localization.LOG_OUT})</S_Out>
                        </S_ProfileName>
                    )}
                    {!user && (
                        <WebButton
                            type="primary"
                            text={Localization.LOGIN}
                            onClick={() => {
                                navigate('/login');
                            }}
                        />
                    )}
                </>
            )}
        </S_MinutePageHeader>
    );
};

const S_MinutePageHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    @media only screen and (min-width: 1260px) {
        padding: 0 50px;
    }
`;

const S_Logo = styled(SVG_Logo)`
    margin: 4px 20px 0 0;
    cursor: pointer;
    svg {
        width: auto;
        height: 50px;
        path {
            fill: ${EColors.DARK};
        }
    }
`;

const S_ProfileName = styled.div`
    color: ${EColors.DARK};
    padding: 0px 10px 0 0;
    display: flex;
    align-items: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 16px;
    color: ${EColors.DARK};
    margin: 0 10px 0 0;
    flex-shrink: 0;
    cursor: pointer;
`;

const S_Profile = styled.span`
    font-size: 18px;
    font-family: ${EFonts.Medium};
    cursor: pointer;
    text-decoration: none;
    margin: 0 12px 0 0;
    &:hover {
        text-decoration: underline;
    }
`;

const S_Out = styled.span`
    font-size: 16px;
    font-family: ${EFonts.Regular};
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;
